import {
  AssetType,
  FireTVCampaignAutomationClient,
} from '@amzn/fire-tv-campaign-automation-service';
import { ASSET_CONFIG } from 'src/configs/assetConfig';
import { AssetState } from 'src/types';
import { IAssetInputHandler } from 'src/types';

import { ImageInputHandler } from '../ImageInputHandler';
import { VideoInputHandler } from '../VideoInputHandler';

/**
 * Creates an asset input handler based on the asset type
 * @param assetType - Type of asset to create handler for
 * @param setState - State setter function for the asset
 * @returns Appropriate handler for the asset type
 */
export const createAssetHandler = (
  assetType: AssetType,
  setState: (state: Partial<AssetState>) => void,
  controlPlaneClient: FireTVCampaignAutomationClient,
): IAssetInputHandler => {
  const config = ASSET_CONFIG[assetType];

  switch (assetType) {
    case AssetType.BACKGROUND_IMAGE:
    case AssetType.LOGO:
      return new ImageInputHandler({
        ...config,
        setState,
        controlPlaneClient,
        assetType,
      });
    case AssetType.VIDEO_TRAILER: {
      if (!config.maxDurationInSeconds) {
        throw new Error(`Missing maxDurationInSeconds for ${assetType}`);
      }
      if (!config.minDurationInSeconds) {
        throw new Error(`Missing minDurationInSeconds for ${assetType}`);
      }
      return new VideoInputHandler({
        ...config,
        maxDurationInSeconds: config.maxDurationInSeconds,
        minDurationInSeconds: config.minDurationInSeconds,
        setState,
        controlPlaneClient,
        assetType,
      });
    }
    default:
      throw new Error(`Unsupported asset type: ${assetType}`);
  }
};
